export default __webpack_public_path__ + "static/media/178.22705765.gif";